import  { Api } from "../utils";

const MattUtilitiesActions = {

  async onLoadMonthsWithCutDates() {
    const url = 'services/app/Settings/GetMonths';
    try {
      const response = await Api.fetchAsync(url);
      Api.validateResponse(response, url);
      return (await response.json()).result;
    } catch(e) {
      return null;
    }
  }

};

export default MattUtilitiesActions;